import * as React from "react"

import { cn } from "@/lib/utils"
import { DateTimeInput } from "./date-time-input"

const inputStyles = "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input"> & { onValidityChange?: (valid: boolean) => void }>(
  ({ className, type, onValidityChange, ...props }, ref) => {
    if (type === "date" || type === "time" || type === "datetime-local") {
      return <DateTimeInput {...props} type={type as "date" | "time" | "datetime-local"} onValidityChange={onValidityChange} className={className} inputClassName={inputStyles} ref={ref} />
    }
    return (
      <input
        type={type}
        className={cn(
          inputStyles,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
